import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DataGrid, {
  Column,
  Editing
} from "devextreme-react/data-grid";
import Form, {
  SimpleItem,
  Label
} from "devextreme-react/form";
import api from "../../services/apiSgtWebKube";
import { Button, LoadIndicator } from "devextreme-react";

function DividaAtiva() {

  const { prefeitura } = useParams(); // pega "ipaporanga.ce"

  const [viewData, setViewData] = useState({ items: [], page: 1, pageCount: 0, loading: false, filterCount: 0 });

  const [nome, setNome] = useState("");
  const [cpfCnpj, setCpfCnpj] = useState("");
  const [situacao, setSituacao] = useState("TODAS");

  function submit() {
    setViewData({ ...viewData, filterCount: viewData.filterCount + 1 });
  }

  useEffect(() => {

    setViewData({ ...viewData, loading: true });

    api.get(`/transparencia/dividaativa/${prefeitura}?nome=${nome}&cpfCnpj=${cpfCnpj}&situacao=${situacao}&page=${viewData.page}`)
      .then(res => {
        const responseData = res.data;
        setViewData({ ...viewData, items: responseData.items, page: responseData.page, pageCount: responseData.pageCount, loading: false });
      })
      .catch(() => {
        setViewData({ ...viewData, items: [], page: 0, pageCount: 0, loading: false });
      });

  }, [viewData.filterCount, viewData.page, viewData.pageCount]);

  const nomeOptions = {
    editorType: "dxTextBox",
    value: nome,
    onValueChanged: (e) => setNome(e.value),
  };

  const cpfCnpjOptions = {
    editorType: "dxTextBox",
    value: cpfCnpj,
    onValueChanged: (e) => setCpfCnpj(e.value),
  };

  const situacaoOptions = {
    editorType: "dxSelectBox",
    searchEnabled: false,
    dataSource: ["TODAS", "INSCRITA", "ACORDADA"],
    value: situacao,
    onValueChanged: (e) => setSituacao(e.value),
  };

  function RenderDataGrid() {

    if (viewData.loading)
      return null;

    return (<DataGrid
      dataSource={viewData.items}
      showBorders={true}
      rowAlternationEnabled={true}
      columnAutoWidth={true}
    >
      <Editing allowDeleting={false} allowUpdating={false}  allowSorting={false}/>
      <Column dataField="credito" caption={"Crédito"} width={110} alignment={"center"} allowSorting={false} />
      <Column dataField="exercicio" caption={"Exercício"} width={110} alignment={"center"}  allowSorting={false}/>
      <Column dataField="inscricao" caption={"Inscrição"} width={110} alignment={"center"}  allowSorting={false}/>
      <Column dataField="nome" caption={"Nome"}  allowSorting={false}/>
      <Column dataField="cpfCnpj" caption={"CPF/CNPJ"} width={160}  allowSorting={false}/>
      <Column dataField="valorOriginal" caption={"Vr. Original"} dataType="money" width={150} format={"R$ #,##0.00"} alignment={"right"}  allowSorting={false}/>
      <Column dataField="total" caption={"Vr. Atualizado"} dataType="money" width={150} format={"R$ #,##0.00"} alignment={"right"}  allowSorting={false}/>
      <Column dataField="situacao" caption={"Situação"} width={120}  allowSorting={false}/>
      <Column dataField="tributo" caption={"Tributo"} width={150}  allowSorting={false}/>
      <Column dataField="parcela" caption={"Parcela"} width={150}  allowSorting={false}/>
    </DataGrid>
    );
  }

  function RenderPager() {

    if (viewData.loading)
      return null;

    return (
      <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 8, justifyContent: "center", width: "100%" }}>
        <Button onClick={() => setViewData({ ...viewData, page: viewData.page - 1 })} disabled={viewData.page <= 1}>
          ◀   Anterior
        </Button>

        <span>
          Página {viewData.page} de {viewData.pageCount}
        </span>

        <Button onClick={() => setViewData({ ...viewData, page: viewData.page + 1 })} disabled={viewData.page >= viewData.pageCount}>
          Próxima  ▶
        </Button>
      </div>
    );
  }

  function RenderLoading() {
    if (!viewData.loading)
      return null;

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",     // centro vertical
          justifyContent: "center", // centro horizontal
          height: "100%",           // ocupa toda a altura do container pai
          minHeight: "150px"        // opcional, evita ficar muito pequeno
        }}
      >
        <LoadIndicator id="large-indicator" height={40} width={40} />
        <span style={{ marginLeft: 8 }}>Atualizando dados...</span>
      </div>
    );
  }

  function RenderDataExtrato() {
    if (viewData.loading)
      return null;

    var dataExtrato = viewData.items.length > 0 ? viewData.items[0].dataExtrato : null;

    if (!dataExtrato)
      return null;

    return (
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",     // centro vertical
          justifyContent: "flex-end", // centro horizontal
        }}
      >
        <span style={{ margin: 15 }}>Dados atualizados em: {dataExtrato}</span>
      </div>
    );
  }


  return (
    <React.Fragment>
      <div className={"content-block"}>
        <div className={"dx-card responsive-paddings home-container"}>
          <h5>RELAÇÃO DA DIVIDA ATIVA CORRENTE</h5>
          <form onSubmit={submit} style={{ padding: "0px 15px" }}>
            <Form
              id="frmPesquisa"
              colCount={10}
              labelLocation={"top"}
            >
              <SimpleItem dataField="nome" colSpan={6} editorType={"dxTextBox"} editorOptions={nomeOptions}>
                <Label text="NOME" />
              </SimpleItem>
              <SimpleItem dataField="cpfCnpj" colSpan={2} editorType={"dxTextBox"} editorOptions={cpfCnpjOptions}>
                <Label text="CPF/CNPJ" />
              </SimpleItem>
              <SimpleItem dataField="situacao" colSpan={2} editorType={"dxSelectBox"} editorOptions={situacaoOptions}>
                <Label text="SITUAÇÃO" />
              </SimpleItem>
            </Form>
            <div
              style={{
                marginTop: "20px",
                marginBottom: "20px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={140}
                  text="Filtrar"
                  type="success"
                  onClick={submit}
                />
              </div>

            </div>
          </form>

          {RenderLoading()}

          {RenderDataExtrato()}

          {RenderDataGrid()}

          {RenderPager()}



        </div>
      </div>
    </React.Fragment>
  );
}

export default DividaAtiva;